import aoflModules from 'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min';

const storeService = aoflModules.store;

const state = function state() {
  var NAMESPACE = 'appSession';
  var ALIAS = 'appSession';
  // Get Graphics Card info
  // src https://gist.github.com/cvan/042b2448fcecefafbb6a91469484cdf8
  var getGraphicsCardInfo = function() {
    const storeGraphicsCardInfo = localStorage.getItem('graphicsCardInfo');
    try {
      if (storeGraphicsCardInfo) return JSON.parse(storeGraphicsCardInfo);
    } catch (e) {}

    var canvas = document.createElement('canvas');
    var webGL;
    var debugInfo;
    var vendor;
    var renderer;

    try {
      webGL =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    } catch (e) {}

    if (webGL) {
      debugInfo = webGL.getExtension('WEBGL_debug_renderer_info');
      vendor = webGL.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
      renderer = webGL.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
    }
    const graphicsCardInfo = {
      vendor: vendor,
      renderer: renderer
    };
    localStorage.setItem('graphicsCardInfo', JSON.stringify(graphicsCardInfo));
    return graphicsCardInfo;
  };
  var mutations = {
    init: function init() {
      var graphicsCardInfo = getGraphicsCardInfo();
      var state = {
        appName: 'ReadingIQ Private',
        appFilter: 'ReadingIQ.com',
        token: '',
        deviceId: '',
        appSessionId: '',
        userAgent: navigator.userAgent,
        appVersion: aofljsConfig.applicationVersion,
        graphicsType: graphicsCardInfo.vendor,
        graphicsVersion: graphicsCardInfo.renderer,
        devicePixelRatio: window.devicePixelRatio,
        shortSideLogicalPixels: Math.min(screen.width, screen.height),
        longSideLogicalPixels: Math.max(screen.width, screen.height),
        operatingSystem: navigator.platform
      };
      return state;
    },
    setDeviceId: function setDeviceId(_moduleState, _payload) {
      return Object.assign({}, _moduleState, {
        deviceId: _payload
      });
    },
    setToken: function setToken(_moduleState, _payload) {
      return Object.assign({}, _moduleState, {
        token: _payload
      });
    },
    setAppSessionId: function setNextState(_moduleState, _payload) {
      return Object.assign({}, _moduleState, {
        appSessionId: _payload
      });
    }
  };

  return {
    namespace: NAMESPACE,
    alias: ALIAS,
    mutations: mutations
  };
};
aoflModules.ready.then(() => storeService.addState(state()));
export default state;
